var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.isAuthenticated
        ? _c("div", { staticClass: "br-header" }, [
            _c("header", { staticClass: "topbar" }, [
              _c(
                "div",
                { staticClass: "brand" },
                [
                  _c("router-link", { attrs: { to: "/", exact: true } }, [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: { src: "/images/logo.png", alt: "Logo" },
                    }),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "view-tabs" }, [
              _c(
                "button",
                {
                  staticClass: "view-tab",
                  class: _vm.myEventSignal.isMonthView == false ? "active" : "",
                  attrs: { "data-view": "day" },
                  on: {
                    click: function ($event) {
                      return _vm.setMonthView(false)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dailyplanner")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "view-tab",
                  class: _vm.myEventSignal.isMonthView == true ? "active" : "",
                  attrs: { "data-view": "month" },
                  on: {
                    click: function ($event) {
                      return _vm.setMonthView(true)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("monthlyplanner")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "br-header-right" }, [
              _c("div", { staticClass: "top-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    attrs: { id: "checksButton" },
                    on: { click: _vm.opencheck },
                  },
                  [_vm._v(_vm._s(_vm.$t("controls")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn primary",
                    attrs: { id: "newActivityButton" },
                    on: { click: _vm.openactivity },
                  },
                  [_vm._v(_vm._s(_vm.$t("actions.newactivity")))]
                ),
              ]),
              _vm._v(" "),
              _c("nav", { staticClass: "nav" }, [
                _c("div", { staticClass: "dropdown" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link nav-link-profile",
                      attrs: {
                        href: "",
                        "data-toggle": "dropdown",
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "logged-name hidden-md-down" },
                        [_vm._v(_vm._s(_vm.user.username))]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wd-32 rounded-circle",
                        attrs: { src: "", alt: "" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "square-10 bg-success" }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu dropdown-menu-header wd-200",
                      staticStyle: {
                        position: "absolute",
                        transform: "translate3d(-18px, 48px, 0px)",
                        top: "0px",
                        left: "0px",
                        "will-change": "transform",
                      },
                      attrs: { "x-placement": "bottom-start" },
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "list-unstyled user-profile-nav" },
                        [
                          _c("li", [
                            _c("a", { on: { click: _vm.logout } }, [
                              _c("i", { staticClass: "icon ion-ios-power" }),
                              _vm._v(" " + _vm._s(_vm.$t("actions.logout"))),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: { "br-mainpanel": _vm.isAuthenticated } }),
      _vm._v(" "),
      _c("router-view", { key: _vm.$route.fullPath }),
      _vm._v(" "),
      _c("vuedal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }